module.exports = __webpack_public_path__ + "img/20200320105234386.4bb047c9.png";